if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class extends ModalDialog {
        initialize() {
            this.querySelectorAll('[data-change-active-media]').forEach(button => {
                button.addEventListener('click', event => {
                    this.activeMediaId = parseInt(
                        event.currentTarget.dataset.mediaId.replace('thumb-', '')
                    );

                    this.showActiveMedia();
                });
            });
        }

        show(opener) {
            super.show(opener);
            this.activeMediaId = opener.getAttribute("data-media-id");

            this.showActiveMedia();
        }

        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.activeMediaId}"])`)
                .forEach((element) => {
                        element.classList.remove('active');
                    }
                );

            const activeMedia = this.querySelector(`[data-media-id="${this.activeMediaId}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();

            if (
                activeMedia.nodeName === 'DEFERRED-MEDIA'
                && activeMediaContent
                && activeMediaContent.querySelector('.js-youtube')
            ) {
                activeMedia.loadContent();
            }

            this.querySelector(`[data-media-id="thumb-${this.activeMediaId}"]`).classList.add('active');

            if (activeMedia.nodeName === 'IMG') {
                this.activateMobilePanzoom(activeMedia);
                this.classList.add('product-media-modal--help-visible');
            } else if (this.panzoom) {
                this.panzoom.dispose();
                this.classList.remove('product-media-modal--help-visible');
            }
        }

        hide() {
            super.hide();

            this.querySelectorAll('video').forEach(video => video.pause());
        }

        activateMobilePanzoom(activeMedia) {
            const shouldPanzoom = BryanAnthonys.device.isMobile() || window.matchMedia('(hover: none)').matches;
            if (!shouldPanzoom) {
                return;
            }

            const viewer = this.querySelector('.product-media-modal__viewer');
            if (viewer) {
                viewer.classList.add('product-media-modal__viewer--panzoomable');
            }

            if (typeof panzoom !== 'function') {
                this.loadPanzoom(activeMedia);

                return;
            }

            const scrollLeft = (activeMedia.clientWidth - activeMedia.parentElement.clientWidth) / 2;
            if (scrollLeft > 0) {
                activeMedia.parentElement.style.left = `-${scrollLeft}px`;
            }

            this.panzoom = panzoom(activeMedia, {
                bounds: true,
                maxZoom: 6,
                minZoom: 0.4,
                initialX: 0,
                initialY: 0,
                boundsPadding: 0
            });

            const onZoom = () => {
                this.classList.remove('product-media-modal--help-visible');
                this.panzoom.off('zoom', onZoom);
            };

            this.panzoom.on('zoom', onZoom);
        }

        loadPanzoom(activeMedia) {
            const panzoomUrlElement = document.querySelector('[data-panzoom-url]');
            if (!panzoomUrlElement) {
                return;
            }

            const panzoomScript = document.createElement('script');
            panzoomScript.type = 'text/javascript';
            panzoomScript.src = panzoomUrlElement.dataset.panzoomUrl;
            panzoomScript.onload = () => this.activateMobilePanzoom(activeMedia);

            const firstScript = document.getElementsByTagName('script')[0];
            firstScript.parentNode.insertBefore(panzoomScript, firstScript);
        }
    });

    customElements.define('product-modal-initializer', class extends HTMLElement {
        connectedCallback() {
            if (typeof this.parentElement.initialize === 'function') {
                this.parentElement.initialize();
            }
        }
    });
}
